import React from 'react';
import { Badge } from './StatusBadge.styles';

// Estados de reserva y actividad → color de marca + etiqueta en español.
const STATUS_MAP = {
  pending:         { color: 'var(--warning-dark)',      label: 'Pendiente' },
  pending_payment: { color: 'var(--warning-dark)',      label: 'Pago pendiente' },
  confirmed:       { color: 'var(--primary)',      label: 'Confirmada' },
  completed:       { color: 'var(--success-dark)', label: 'Completada' },
  cancelled:       { color: 'var(--danger-dark)',  label: 'Cancelada' },
  active:          { color: 'var(--success-dark)', label: 'Activa' },
  inactive:        { color: 'var(--text-secondary)',   label: 'Inactiva' },
  draft:           { color: 'var(--warning-dark)',      label: 'Borrador' },
  held:            { color: 'var(--primary)',      label: 'Retenido' },
  released:        { color: 'var(--success-dark)', label: 'Liberado' },
  refunded:        { color: 'var(--text-secondary)',   label: 'Reembolsado' },
  verified:        { color: 'var(--success-dark)', label: 'Verificada' },
  // promotores (fase 4): los textos finales los pone cada pantalla con `children`
  approved:        { color: 'var(--success-dark)', label: 'Aprobado' },
  rejected:        { color: 'var(--danger-dark)',  label: 'Rechazado' },
  suspended:       { color: 'var(--warning-dark)', label: 'Suspendido' },
  accepted:        { color: 'var(--success-dark)', label: 'Aceptada' },
  revoked:         { color: 'var(--text-secondary)', label: 'Revocada' },
  open:            { color: 'var(--warning-dark)', label: 'Abierto' },
  paid:            { color: 'var(--success-dark)', label: 'Pagado' },
  valid:           { color: 'var(--success-dark)', label: 'Vigente' },
};

export const statusLabel = (status) =>
  STATUS_MAP[status]?.label || status || 'Desconocido';

const StatusBadge = ({ status, children }) => {
  const entry = STATUS_MAP[status] || { color: 'var(--text-secondary)' };

  return (
    <Badge $color={entry.color}>
      {children || entry.label || status}
    </Badge>
  );
};

export default StatusBadge;
